import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ChatCenteredText} from '../../../icons';
import {attributeHelpCenterClick, prefetchHelpCenterIdentity} from '../../../../utils/HelpCenterAttribution';
import {NS, formatAmount} from './subscriptionPageModel';
import {openSupportChat, recordSubscriptionEvent} from './subscriptionRequests';

const HELP_CENTER_URL = 'https://ayuda.dashbo.io';
const FAQ_COUNT = 5;

/**
 * «Ahorra con el pago anual» (mockup 1, derecha). Lo decide `annualOffer`: sólo si ahorra contra lo que
 * paga hoy. Los textos llevan `<strong>` y se insertan como HTML, así que la interpolación queda ESCAPADA
 * (los montos los arma la pantalla, pero el escape no se apaga donde se inyecta marcado).
 */
export function AnnualOfferCard({planName, offer, onAnnual}) {
    const {t, i18n} = useTranslation();
    const lang = i18n && i18n.language;
    return (
        <section className="sp-card sp-annual" aria-labelledby="sp-annual-title">
            <p className="sp-eyebrow -plum">{t(`${NS}.annual.eyebrow`)}</p>
            <h2 id="sp-annual-title" className="sp-card__title">
                {t(`${NS}.annual.title`, {
                    plan: planName, price: formatAmount(offer.monthly, offer.currency, lang),
                    interpolation: {escapeValue: false},
                })}
            </h2>
            <p className="sp-annual__body" dangerouslySetInnerHTML={{
                __html: t(`${NS}.annual.body`, {savings: formatAmount(offer.savings, offer.currency, lang)}),
            }}/>
            <p className="sp-annual__detail">
                {t(`${NS}.annual.detail`, {
                    total: formatAmount(offer.total, offer.currency, lang), interpolation: {escapeValue: false},
                })}
            </p>
            <div className="sp-actions">
                <button type="button" className="btn -alt -negative sp-btn-block" onClick={onAnnual}>
                    {t(`${NS}.annual.cta`)}
                </button>
            </div>
        </section>
    );
}

/** Las preguntas frecuentes, con `<details>` nativo, y la salida al chat. */
export function FaqCard() {
    const {t} = useTranslation();
    useEffect(() => { prefetchHelpCenterIdentity(); }, []);

    const onToggle = (index) => (event) => {
        if (event.currentTarget.open) recordSubscriptionEvent(`faq_open_${index}`);
    };

    return (
        <section className="sp-card sp-faq" aria-labelledby="sp-faq-title">
            <h2 id="sp-faq-title" className="sp-card__title">{t(`${NS}.faq.title`)}</h2>
            <div className="sp-faq__list">
                {Array.from({length: FAQ_COUNT}, (_, i) => i + 1).map((index) => (
                    <details key={index} onToggle={onToggle(index)}>
                        <summary>{t(`${NS}.faq.q${index}`)}</summary>
                        <p>{t(`${NS}.faq.a${index}`)}</p>
                    </details>
                ))}
            </div>
            <div className="sp-faq__foot">
                <button type="button" className="btn -alt -negative sp-btn-block" onClick={openSupportChat}>
                    <ChatCenteredText size={18} aria-hidden="true"/>
                    {t(`${NS}.faq.chat`)}
                </button>
                <a className="sp-link" href={HELP_CENTER_URL} data-help-url={HELP_CENTER_URL} target="_blank"
                   rel="noopener noreferrer" onMouseDown={attributeHelpCenterClick} onClick={attributeHelpCenterClick}>
                    {t(`${NS}.faq.help_center`)}
                </a>
            </div>
        </section>
    );
}
